import { render, staticRenderFns } from "./StockInfoEdit.vue?vue&type=template&id=72dde794&scoped=true&"
import script from "./StockInfoEdit.vue?vue&type=script&lang=js&"
export * from "./StockInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./StockInfoEdit.vue?vue&type=style&index=0&id=72dde794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dde794",
  null
  
)

export default component.exports